import React from 'react'
import cx from 'classnames'

import styles from './Text.module.scss'

export const Text = ({ children, className }) => (
  <p className={cx(styles.text, { [className]: Boolean(className) })}>
    {children}
  </p>
)
